module.exports = __webpack_public_path__ + "static/media/UploadArtifactPromptImage.2f6ad8d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/UploadArtifactPromptImage.png
// module id = 293
// module chunks = 0